export default {
  invalidEmail: 'hooks.form-validation.invalid-email',
  invalidPassword: 'hooks.form-validation.invalid-password',
  invalidConfirmPassword: 'hooks.form-validation.invalid-confirm-password',
  invalidPhoneNumber: 'hooks.form-validation.invalid-phone-number',
  invalidAgreement: 'hooks.form-validation.invalid-agreement'
}
